import {observer} from "mobx-react";
import {useEffect} from "react";
import {useParams} from "react-router-dom";
import usePage from "../../../components/layouts/base-page-layout/page-hook";
import ListLayout, { LIST_LAYOUT_SPACING_VARIANT } from "../../../components/layouts/list-layout/list-layout";
import currentPortalStore from "../../../stores/current-portal-store";
import RmaDraftOrderCard from "./components/rma-payments-exchanges-card/rma-payments-exchanges-card";
import ItemDrawer from "./components/rma-product-case-drawer/rma-product-case-drawer";
import RmaItems from "./components/rma-items-card/rma-items-card";
import RmaShipmentsCard from "./components/rma-page-shipments-card/rma-page-shipments-card";
import RmaPageDataCards from "./components/rma-page-data-cards/rma-page-data-cards";
import TimelineCard from "./components/timeline-card/timeline-card";
import rmaPageMainStore from "./stores/rma-page-main-store";
import RmaActionsToolbar from "./components/rma-actions-toolbar/rma-actions-toolbar";
import RmaNavigation from "./components/rma-navigation/rma-navigation";
import RmaPageNewItemsCard from "./components/rma-new-items-card/rma-new-items-card";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../stores/rms-mixpanel-store";
import showSbrPageStore from "../rma-list-page/stores/show-sbr-page.store";

const RmaPage: React.FC = observer(() => {
	const { setHasBack, setSubTitles, setInstruction } = usePage();
	const params = useParams();
	const rmaId = params.rmaId;
    const rmaPageStore = rmaPageMainStore.getRmaPageStore();
    const rmaProductCaseList = rmaPageStore?.customerCaseStore?.productCaseList ?? [];

    useEffect(() => {
        if (rmaId) {
            rmaPageMainStore.setRmaPageStore(Number(rmaId));
        }
    }, [rmaId]);

	useEffect(() => {
        currentPortalStore.load();
        rmsMixpanelStore.load();
        showSbrPageStore.fetchShowSBRPageOnce();
	}, []);

    const {getTranslation} = useDashboardTranslation();
    const scope = 'dashboard-returns-page';
    const subTitle = `${getTranslation('RMA', scope)}${rmaPageStore?.rmaId}`;


	useEffect(() => {
		setHasBack(true);
		setSubTitles([subTitle]);
        setInstruction();
	}, [setHasBack, setSubTitles, rmaPageStore?.rmaId, setInstruction, subTitle]);

    if (!rmaPageStore) {
        return null;
    }

    return (
        <div className="rma-page-container">
            <RmaNavigation
                nextRmaId={rmaPageMainStore.nextRmaId}
                prevRmaId={rmaPageMainStore.prevRmaId}
                disabled={rmaPageStore.isLoading}
                currentRmaId={rmaPageStore.rmaId}
            />
            <ListLayout spacingVariant={LIST_LAYOUT_SPACING_VARIANT.SMAll}>
                <RmaPageDataCards store={rmaPageStore}/>
                <RmaItems isLoading={rmaPageStore.isLoading} isActionable={!rmaPageStore.customerCaseStore?.isCancelResolution()} productCaseList={rmaProductCaseList} customerCaseStore={rmaPageStore.customerCaseStore}/>
                {rmaPageStore.shouldDisplayNewItemsCard && <RmaPageNewItemsCard isLoading={rmaPageStore.isLoading} customerCaseStore={rmaPageStore.customerCaseStore}/>}
                <ItemDrawer customerCaseStore={rmaPageStore.customerCaseStore} rmaPageStore={rmaPageStore}/>
                <RmaShipmentsCard shipmentsList={rmaPageStore.shipmentList} rmaPageStore={rmaPageStore} customerCaseStore={rmaPageStore.customerCaseStore} />
                {rmaPageStore.shouldDisplayPaymentsExchangesCard && <RmaDraftOrderCard customerCaseStore={rmaPageStore.customerCaseStore!} storeCurrencyCode={rmaPageStore.storeCurrency}/>}
                { rmaPageStore.timelineListManager && <TimelineCard timelineManagerStore={rmaPageStore.timelineListManager} rmaMainStore={rmaPageStore}/> }
            </ListLayout>
            <RmaActionsToolbar rma={rmaPageStore} />
		</div>
	);
});
export default RmaPage;
